import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e927e6f0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content" }
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = ["src"]
const _hoisted_4 = ["src"]

import { onMounted, ref, reactive } from 'vue';
import { useI18n } from 'vue-i18n';
import TemplateRequest from '../../data/TemplateRequest';


export default /*#__PURE__*/_defineComponent({
  __name: 'Template-004',
  props: {
    view_key: {}
  },
  setup(__props: any) {

const props = __props;

const img0 = ref('');
const img1 = ref('');
const img2 = ref('');

const rootStyleObj = reactive({
  backgroundImage: '',
});
const { t } = useI18n();

onMounted(() => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  var cardData: any = TemplateRequest.getViewDataByKey(props.view_key);
  img0.value = cardData.img0;
  img1.value = cardData.img1;
  img2.value = cardData.img2;
  rootStyleObj.backgroundImage = `url(${cardData.img3})`;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "root",
    style: _normalizeStyle({ ...rootStyleObj })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", {
        src: img0.value,
        alt: _unref(t)('common.wpsOffice'),
        class: "logo-icon"
      }, null, 8, _hoisted_2),
      _createElementVNode("img", {
        src: img1.value,
        alt: "",
        class: "icon1"
      }, null, 8, _hoisted_3),
      _createElementVNode("img", {
        src: img2.value,
        alt: "",
        class: "content-icon"
      }, null, 8, _hoisted_4)
    ])
  ], 4))
}
}

})